import {createStore} from 'vuex'
import persistedState from 'vuex-persistedstate'

export default createStore({
    state: {
        tagsList: [],
        collapse: false,
        developer: sessionStorage.getItem('developer') || 0,
        ismsgBox: 0,
        titleText: '添加FAQ',
        language:'zh_CN',
        fullPath:''
    },
    mutations: {
        delTagsItem(state, data) {
            state
                .tagsList
                .splice(data.index, 1);
        },
        setTagsItem(state, data) {
            state
                .tagsList
                .push(data)
        },
        clearTags(state) {
            state.tagsList = []
        },
        closeTagsOther(state, data) {
            state.tagsList = data;
        },
        closeCurrentTag(state, data) {
            for (let i = 0, len = state.tagsList.length; i < len; i++) {
                const item = state.tagsList[i];
                if (item.path === data.$route.fullPath) {
                    if (i < len - 1) {
                        data
                            .$router
                            .push(state.tagsList[i + 1].path);
                    } else if (i > 0) {
                        data
                            .$router
                            .push(state.tagsList[i - 1].path);
                    } else {
                        data
                            .$router
                            .push("/");
                    }
                    state
                        .tagsList
                        .splice(i, 1);
                    break;
                }
            }
        },
        // 侧边栏折叠
        handleCollapse(state, data) {
            state.collapse = data;
        },
        // 开发者中心侧边栏
        handleDeveloper(state, data) {
            state.developer = data;
        },
        // 改变box状态
        changemsgBox(state, data) {
            state.ismsgBox = data;
        },
        changeLanguage(state, data) {
            state.language = data;
            localStorage.setItem('smartAdultLanguage',data);
        },
        changeTitleText(state, data){
            state.titleText = data;
        },
        setFullPath(state, data){
            state.fullPath = data;
        }
    },
    actions: {},
    modules: {},
    plugins: [persistedState()]
})
